<span class="version-container"><nx-superprep-version></nx-superprep-version></span>
<div #container>
  <span #react></span>
</div>
@if (!isReact) {
<div class="headerlte-container" [ngClass]="rootClassName">
  <span class="version-container"><nx-superprep-version></nx-superprep-version></span>
  <div class="headerlte-limited">
    <div class="headerlte-row">
      <div class="headerlte-col-left">
        <ng-containter [ngTemplateOutlet]="_left"></ng-containter>
      </div>
      <div class="headerlte-col-center" (click)="menu=false">
        <ng-containter [ngTemplateOutlet]="_center"></ng-containter>
      </div>
      <div class="headerlte-col-right" [ngStyle]="{'flex-grow':isWeb ? '0':'0.1'}" (click)="menu=false">
        <ng-containter [ngTemplateOutlet]="_right"></ng-containter>
      </div>
    </div>
  </div>
</div>
}
<ng-template #_left>
  @if (isWeb) {
    <div class="headerlte-brandlte" (click)="onSelect('home')">
      <img loading="eager" [attr.src]="logo.src" [attr.alt]="logo.alt" [attr.width]="logo.width" [attr.height]="logo.height" class="headerlte-frame">
    </div>
  } @else {
    <ng-containter [ngTemplateOutlet]="_menu"></ng-containter>
  }
</ng-template>
<ng-template #_center>
  @if (isWeb) {
    @for (entry of entries; track $index) {
      @if(title(entry) === 'Performance') {
      <button tourAnchor='anchor.header.performance' class="headerlte-textbutton" (click)="onSelect(entry)" [ngClass]="{ 'active': isActive(entry)}">
        <span class="headerlte-text">{{title(entry)}}</span>
      </button>
      } @else {
        <button class="headerlte-textbutton" (click)="onSelect(entry)" [ngClass]="{ 'active': isActive(entry)}">
          <span class="headerlte-text">{{title(entry)}}</span>
        </button>
      }
    }
  } @else {
    <div class="headerlte-brandlte" (click)="onSelect('home')">
      <img loading="eager" [attr.src]="logo.src" [attr.alt]="logo.alt" [attr.width]="logo.width" [attr.height]="logo.height" class="headerlte-frame">
    </div>
    <!--div class="headerlte-title"><span class="headerlte-text">{{title(this.activeTab)}}</span></div-->
  }
</ng-template>
<ng-template #_right>
  @if (isWeb) {
    <button class="headerlte-flatbutton" (click)="onSelect('join')" [ngClass]="{ 'active': isActive('join')}">
      <span class="headerlte-text">{{title('join')}}</span>
    </button>
  }
  <div class="headerlte-avatarname">
    @if (isWeb) {
      <div class="headerlte-avatarbutton" (click)="profileMenuTrigger.toggleMenu()">
        <pop-ui-avatar></pop-ui-avatar>
      </div>
      <div class="headerlte-avatar-frame">
        <span class="headerlte-avatar-text labelboldsmall" (click)="profileMenuTrigger.toggleMenu()">
          <span>{{profileName}}</span>
        </span>
        <button mat-icon-button [matMenuTriggerFor]="_profileMenu" #profileMenuTrigger="matMenuTrigger" color="profile-light" aria-label="profile">
          <mat-icon [ngStyle]="{'transition':'0.5s', 'transform': profileMenuTrigger.menuOpen ? 'rotate(180deg)' : ''}">keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #_profileMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="onSelect('profile')">Settings</button>
            <button mat-menu-item (click)="onSelect('logout')">Log Out</button>
            @if(isDebugMode) {
              <button mat-menu-item (click)="onSelect('popstudy')">PopStudy</button>
              <button mat-menu-item (click)="onSelect('popquiz')">PopQuiz</button>
              <button mat-menu-item (click)="onSelect('popteams')">PopTeams</button>
              <button mat-menu-item (click)="onSelect('popstack')">PopStack</button>
            }
          </ng-template>
        </mat-menu>
      </div>
    } @else {
      <button class="headerlte-avatarbutton" (click)="onSelect('profile')">
        <pop-ui-avatar></pop-ui-avatar>
      </button>
    }
  </div>
</ng-template>

<ng-template #_menu>
  <div dropdown [isAnimated]="false" [autoClose]="true">
    <button
      (click)="menu=true"
      id="button-container"
      class="btn pt-0 dropdown-toggle"
      dropdownToggle type="button"
      aria-controls="dropdown-container">
      <span class="navbar-toggler-icon" [style.color]="'white'">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox='0 0 30 30'>
          <path stroke='currentColor' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'></path>
        </svg>
      </span>
    </button>
   <!--ul id="dropdown-container" *dropdownMenu data-bs-theme="dark" class="dropdown-menu" role="menu" aria-labelledby="button-container" [style.color]="'white'" [style.background-color]="'#381A99'">
      @for (entry of entries; track $index) {
        <li role="menuitem" (click)="onSelect(entry)" [ngClass]="{ 'active': isActive(entry)}"><span class="dropdown-item" href="#">{{title(entry)}}</span></li>
      }
    </ul-->
  </div>
</ng-template>

<ng-template #_menu1>
  <div dropdown container="body" [isAnimated]="true" [autoClose]="true" [insideClick]="true">
    <button
      id="button-container"
      class="btn pt-0 dropdown-toggle"
      dropdownToggle type="button"
      aria-controls="dropdown-container">
      <span class="navbar-toggler-icon navbar navbar-expand-lg bg-transparent pt-0" [style.color]="'white'">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox='0 0 30 30'>
          <path stroke='currentColor' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'></path>
        </svg>
      </span>
    </button>
    <ul id="dropdown-container" *dropdownMenu data-bs-theme="dark" class="dropdown-menu" role="menu" aria-labelledby="button-container" [style.color]="'white'" [style.background-color]="'#381A99'">
      @for (entry of entries; track $index) {
        <li role="menuitem" (click)="onSelect(entry)" [ngClass]="{ 'active': isActive(entry)}"><span class="dropdown-item" href="#">{{title(entry)}}</span></li>
      }
    </ul>
  </div>
</ng-template>

<ng-template #_confirmLogout>
  <div class="modal-header border-0">
    <h4 class="modal-title pull-left headingboldsmall"> Are you sure ?</h4>
    <button type="button" class="btn btn-xs btn-close close pull-right" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Signing out without creating an account will erase your study history and progress tracking. Create an account now to safeguard your data and enhance your learning experience !</p>
    <div class="text-center">
      <button type="button" class="btn btn-primary" (click)="create()">Create Account</button>
      <button type="button" class="btn btn-default" (click)="signout()">I don't care. Sign out</button>
    </div>
  </div>
</ng-template>
